import { render, staticRenderFns } from "./fulfillment-centers.vue?vue&type=template&id=9fbb8dba&scoped=true&"
import script from "./fulfillment-centers.vue?vue&type=script&lang=js&"
export * from "./fulfillment-centers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbb8dba",
  null
  
)

export default component.exports